import { GetServerSideProps } from "next";
import Head from "next/head";
import React from "react";
import AuthModule from "../../../modules/auth/auth";
import {
  mapSellerProfileResultToSellerProfile,
  SellerProfile,
} from "../../../stores/seller-store/seller-store.model";
import { ACCESS_TOKEN } from "../../../utils/cookie";
import { isCrediMart, isCrediStore } from "../../../utils/helper";

interface AuthPageProps {
  sellerData: SellerProfile;
}

const AuthPage = ({ sellerData }: AuthPageProps) => {
  return (
    <>
      <Head>
        <title>{`Verifikasi OTP | ${process.env.NEXT_PUBLIC_BRAND_NAME}`}</title>
      </Head>
      <AuthModule sellerData={sellerData} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  req,
  query,
}) => {
  try {
    const { seller: sellerUsername } = query;
    const accessToken = req.cookies[ACCESS_TOKEN];
    if (accessToken && query.from !== "checkout") {
      return {
        redirect: {
          permanent: false,
          destination: `/${sellerUsername}/order`,
        },
      };
    }

    const sellerResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/guest/seller-profile?username=${sellerUsername}`
    );
    const sellerJson = await sellerResponse.json();
    const sellerData = mapSellerProfileResultToSellerProfile(sellerJson);

    // restrict access by seller type
    if (
      !sellerData ||
      (isCrediMart() && !sellerData?.sellerJopan) ||
      (isCrediStore() && sellerData?.sellerJopan)
    ) {
      return {
        redirect: {
          permanent: false,
          destination: "/",
        },
      };
    }

    return {
      props: {
        sellerData,
      },
    };
  } catch (err) {
    return { props: {} };
  }
};

export default AuthPage;
